import { render } from "./HomePage.vue?vue&type=template&id=178e018e"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=178e018e&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__